<template>
  <main id="error" class="animated fadeIn">
    <h1>Error {{ errorData.status }}</h1>
    <p>{{ $t(`errors.${errorData.status}.msg`) }}</p>
    <button class="redir-btn" @click="redirect">
      {{ $t(`errors.${errorData.status}.redir_btn`) }}
    </button>
  </main>
</template>

<script>
export default {
  computed: {
    errorData: function() {
      return this.$store.getters["global/errorData"];
    }
  },
  beforeMount: function() {
    if (!this.errorData) this.$router.push({ name: "Dashboard" });
  },
  methods: {
    redirect: function() {
      if (typeof this.errorData.route_to === "number"){
        this.$router.go(this.errorData.route_to);
      } else {
        this.$router.push({ name: this.errorData.route_to })
      }
      return true

      if (!this.errorData || this.errorData.status === 401 || this.errorData.status === 403) {
        this.logout();
      }
    },
    logout: async function() {
      try {
        await this.$store.dispatch("session/AUTH_LOGOUT");
        this.$router.push({
          name: "Login"
        });
      } catch (error) {
        throw error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#error {
  margin: 4rem;
}
.redir-btn {
  @extend %audi;
  color: $white;
  background-color: $black;
  padding: 10px 20px;
  border: 1px solid $black;
  border-radius: 0px;
}
</style>
